import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import NavigationBar from '../components/NavigationBar';
import Footer from '../pages/Footer';
import { siteConfig } from '../constant/siteConfig';

const Main = () => {
    useEffect(() => {
        document.title = siteConfig.appName;

        const upsertLink = (rel, href) => {
            let link = document.querySelector(`link[rel='${rel}']`);
            if (!link) {
                link = document.createElement('link');
                link.setAttribute('rel', rel);
                document.head.appendChild(link);
            }
            link.setAttribute('href', href);
        };

        const upsertMeta = (name, content) => {
            let meta = document.querySelector(`meta[name='${name}']`);
            if (!meta) {
                meta = document.createElement('meta');
                meta.setAttribute('name', name);
                document.head.appendChild(meta);
            }
            meta.setAttribute('content', content);
        };

        upsertLink('icon', siteConfig.faviconUrl);
        upsertLink('shortcut icon', siteConfig.faviconUrl);
        upsertLink('apple-touch-icon', siteConfig.faviconUrl);
        upsertMeta('description', siteConfig.metaDescription || siteConfig.appName);
        upsertMeta('theme-color', siteConfig.brandColors.primary);
    }, []);

    return (
        <div className='h-screen flex flex-col overflow-hidden' style={{ backgroundColor: siteConfig.brandColors.secondary }}>
            <NavigationBar />
            <main className='flex-1 min-h-0 overflow-y-auto'>
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default Main;
